import { axios } from "utils";

import { PUBLIC_NEWS_URL as endpoint } from "consts";

import { Article, ArticleCard } from "models";

export const getNewNews = async (data?: { signal?: AbortSignal }): Promise<ArticleCard[]> => axios.get(`${endpoint}/new`, { data, signal: data?.signal });

export const getFullNews = async (data: { link: string; signal: AbortSignal }): Promise<Article> =>
  axios.get(`${endpoint}/${data.link}`, { data, signal: data.signal });

export const getRelatedNews = async (data: { link: string; signal: AbortSignal }): Promise<Article[]> =>
  axios.get(`${endpoint}/${data.link}/related`, { data, signal: data.signal });
